import {
  SET_POTALCODES,
  SET_POSTALCODE_REQUEST,
  SET_TERRITORY_REQUEST,
  SET_SELECTED_TERRITORY,
  SET_TERRITORIES, SET_SELECTED_LOADCLASS, SET_TERRITORY_COLORS
} from '../actions/types';

const initialState = {
  postalcodes: [],
  territories: [],
  colors: {},
  selected_territory: undefined,
  selected_load_class: undefined,
  postal_request: {
    page: 0,
    num_results: 0,
    results_per_page: 600
  },
  territory_request: {
    page: 1,
    num_results: 0,
    total_pages: 1,
    results_per_page: 20
  }
};

export default function territoryReducer (state = initialState, { type, data }) {
  switch (type) {
  case SET_POTALCODES:
    return ({
      ...state,
      postalcodes: data
    });
  case SET_POSTALCODE_REQUEST:
    return ({
      ...state,
      postal_request: data
    });
  case SET_TERRITORIES:
    return ({
      ...state,
      territories: data
    });
  case SET_TERRITORY_REQUEST:
    return ({
      ...state,
      territory_request: {
        ...state.territory_request,
        ...data
      }
    });
  case SET_SELECTED_TERRITORY:
    return ({
      ...state,
      selected_territory: data
    });
  case SET_SELECTED_LOADCLASS:
    return ({
      ...state,
      selected_load_class: data
    });
  case SET_TERRITORY_COLORS:
    return ({
      ...state,
      colors: data
    });
  default:
    return state;
  }
}
